module.exports = __webpack_public_path__ + "img/car_breaks.c9570245.svg";